const getUserFullName = <T extends { firstName?: string; lastName?: string; }>(
  obj: T,
  startFromLastName?: boolean,
) => {
  if (obj.lastName && obj.firstName) {
    if (startFromLastName) {
      return `${obj.lastName} ${obj.firstName}`;
    }

    return `${obj.firstName} ${obj.lastName}`;
  }

  if (obj.firstName) {
    return obj.firstName;
  }

  if (obj.lastName) {
    return obj.lastName;
  }

  return undefined;
};

export default getUserFullName;
